/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-09-09 09:33:53
 * @modify date 2021-09-09 09:33:53
 * @desc [用户信息]
 */
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import moment from 'moment';
import queryString from 'query-string';
import { EnumAPI } from '../../apis/index';
import {
  EnumBusiness,
  EnumCaptchaType,
  EnumPhoneMsgScene,
  EnumProtocol,
  EnumStatusCode,
  EnumUserErrType,
  EnumUserSourceType,
} from '../../enums';
import { AjaxBasics, BaseModel, Regulars } from '../../libraries';
import { ProtocolController } from '../protocol/index';
import { onCreateFactoryUser } from './userModel';
@BindAll()
export class UserInfoController {
  /**
   * 用户信息
   * @memberof SystemController
   */
  readonly User = onCreateFactoryUser();
  /**
   * 协议
   * @memberof SystemController
   */
  Protocol = new ProtocolController();

  readonly BaseInfo = new BaseModel({ type: 'object', storageKey: 'baseInfo' });
  query = {};
  checkcode: any = '';

  @computed
  get mobile() {
    return (
      lodash.get(this.User.value, 'mobile') ||
      lodash.get(this.User.value, 'bindMobile')
    );
  }
  @computed
  get username() {
    return (
      this.User.username || lodash.get(this.User.value, 'loginUsername', '')
    );
  }
  @computed
  get is12Login() {
    return lodash.size(this.username) == 12;
  }
  @computed
  get isMobileLogin() {
    return Regulars.mobile_phone.test(this.username);
  }
  /**
   * 是否k码登录
   */
  @computed
  get isKCodeLogin() {
    return lodash.startsWith(
      lodash.toLower(this.username),
      lodash.toLower('k'),
    );
  }

  /**
   * 是否D码登录
   */
  @computed
  get isDCodeLogin() {
    return lodash.startsWith(
      lodash.toLower(this.username),
      lodash.toLower('d'),
    );
  }

  /**
   * 是否K或者D码登录
   */
  @computed
  get isKorDLogin() {
    return this.isKCodeLogin || this.isDCodeLogin;
  }

  /**
   * oauth2 ===
   */

  get loginSourceAppId() {
    // 登陆后返回的
    return lodash.get(this.User.value, 'sourceAppId', '');
  }

  get localSourceAppId() {
    //地址栏中携带的
    return lodash.get(this.query, 'appId', '');
  }

  get defaultSourceAppId() {
    return this.localSourceAppId || EnumUserSourceType.bppNew;
  }

  get localRedirectUrl() {
    // 地址栏中获取的
    return lodash.get(this.query, 'redirectUrl', '');
  }
  get localRedirectUrlBlank() {
    // 地址栏中获取的
    return lodash.get(this.query, 'redirectBlank', '');
  }

  get pcRedirectUrl() {
    // baseInfo接口获取的
    return lodash.get(this.BaseInfo.value, 'appInfo.pcRedirectUrl', '');
  }

  get h5RedirectUrl() {
    // baseInfo接口获取的
    return lodash.get(this.BaseInfo.value, 'appInfo.h5RedirectUrl', '');
  }

  get callback() {
    // h5存的callback路径
    return lodash.get(this.query, 'callback', '');
  }

  get isRelForLogin() {
    return lodash.eq(this.loginSourceAppId, EnumUserSourceType.rel);
  }

  get isRelForLocal() {
    return lodash.eq(this.localSourceAppId, EnumUserSourceType.rel);
  }

  get isIsgForLogin() {
    return lodash.eq(this.loginSourceAppId, EnumUserSourceType.isg);
  }

  get isRelOrIsg() {
    return this.isRelForLogin || this.isIsgForLogin;
  }

  get smbRegisterOrgInfo() {
    return lodash.get(this.User.value, 'smbRegisterOrgInfo', {});
  }
  get registedManagerInfo() {
    return lodash.get(this.User.value, 'registedManagerInfo', {});
  }

  isYxt(appId) {
    return lodash.some(
      [
        EnumUserSourceType.yxtSitMain,
        EnumUserSourceType.yxtSitRel,
        EnumUserSourceType.yxtSitMiddle,
        EnumUserSourceType.yxtSitCon,
        EnumUserSourceType.yxtProdMain,
        EnumUserSourceType.yxtProdRel,
        EnumUserSourceType.yxtProdMiddle,
        EnumUserSourceType.yxtProdCon,
        EnumUserSourceType.yxtNewSit,
        EnumUserSourceType.yxtSit,
        EnumUserSourceType.yxtProd,
      ],
      (yxtAppId) => lodash.eq(appId, yxtAppId),
    );
  }

  /**
   * 密码强度低，修改密码 ====
   */

  get pwdEditPos() {
    const sourceAppId =
      this.localSourceAppId ||
      lodash.get(this.User.value, 'lowPwdInfo.sourceAppId');
    return lodash.eq(sourceAppId, EnumUserSourceType.bppNew)
      ? '账号中心'
      : '安全设置';
  }

  get pwdEditLastDate() {
    const forceUpdateTime = lodash.get(
      this.User.value,
      'lowPwdInfo.forceUpdateTime',
    );
    return forceUpdateTime
      ? moment(forceUpdateTime).format('YYYY年MM月DD日')
      : '';
  }

  get isPwdOverTime() {
    return !lodash.get(this.User.value, 'lowPwdInfo.idToken');
  }

  /**
   * oauth流程
   * @memberof SystemController
   */
  async onAuthorize(isPc?) {
    // let body = lodash.get(this.BaseInfo.value, 'query')
    let body = this.query;
    const appId = lodash.get(body, 'appId');
    if (!appId) {
      await this.getAppBaseInfo(this.loginSourceAppId);
      body = {
        appId: this.loginSourceAppId,
        scope: this.isIsgForLogin ? 'basic,wechat' : 'basic',
        redirectUrl: isPc ? this.pcRedirectUrl : this.h5RedirectUrl,
      };
    } else {
      let redirectUrl = lodash.get(body, 'redirectUrl');
      if (!lodash.includes(redirectUrl, 'http')) {
        body = lodash.set(body, 'redirectUrl', `http://${redirectUrl}`);
      }
    }
    const res: any = await AjaxBasics.request(
      lodash.merge({}, EnumAPI.wechat_authorize, {
        body,
      }),
    );
    let { state, redirectUrl, code } = res;
    const isYxt = this.isYxt(lodash.get(body, 'appId'));
    const codeKey = isYxt ? 'authCode' : 'auth_code';
    let query = lodash.pickBy({ [codeKey]: code, state }, lodash.identity);
    if (lodash.includes(redirectUrl, '?')) {
      query = lodash.assign(
        query,
        queryString.parse(lodash.split(redirectUrl, '?')[1]),
      );
      redirectUrl = lodash.split(redirectUrl, '?')[0];
    }
    const url = queryString.stringifyUrl({
      url: encodeURIComponent(redirectUrl),
      query,
    });
    return url;
  }

  // 上游系统在bpp做中转单点跳转到目标页
  async onUpstreamAuthorize(body) {
    const res: any = await AjaxBasics.request(
      lodash.merge({}, EnumAPI.wechat_authorize, {
        body,
      }),
    );
    let { state, redirectUrl, code } = res;

    let query = lodash.pickBy({ auth_code: code, state }, lodash.identity);
    // 处理参数
    if (lodash.includes(redirectUrl, '?')) {
      query = lodash.assign(
        query,
        queryString.parse(lodash.split(redirectUrl, '?')[1]),
      );
      redirectUrl = lodash.split(redirectUrl, '?')[0];
    }
    const url = queryString.stringifyUrl({
      url: redirectUrl,
      query,
    });
    return url;
  }

  /**
   * 登录成功后根据用户类型做处理
   * @memberof SystemController
   */
  async onHandleLogined() {
    let sourceAppId = this.localSourceAppId || this.loginSourceAppId;
    const oauth = lodash.eq(String(lodash.get(this.query, 'oauth')), 'true');
    const isIsg = lodash.eq(sourceAppId, EnumUserSourceType.isg);
    const isRel = lodash.eq(sourceAppId, EnumUserSourceType.rel);
    const isDsr = lodash.eq(sourceAppId, EnumUserSourceType.dsr);
    const KNum = lodash.startsWith(lodash.toUpper(this.User.username), 'K');

    if (!sourceAppId) {
      throw { error: EnumUserErrType.unLogin };
    } else if (
      oauth || //需要走oauth接口的标识
      (isIsg && this.localSourceAppId) || //isg并且是引流
      (isRel && this.localSourceAppId) || //rel并且是引流
      (isRel && !this.localSourceAppId && !KNum) || //rel不是引流并且不是k码
      lodash.eq(sourceAppId, EnumUserSourceType.developer) || // 开发者平台
      isDsr // dsr
    ) {
      throw { error: EnumUserErrType.oauth };
    } else {
      sourceAppId = isIsg || isRel ? this.defaultSourceAppId : sourceAppId;
      await this.getAppBaseInfo(sourceAppId);
      throw { error: EnumUserErrType.other };
    }
  }

  /**
   * 获取来源app的基本信息，包括domain、微信AppId
   */
  async getAppBaseInfo(sourceAppId) {
    try {
      const res: any = await AjaxBasics.request({
        ...EnumAPI.accountsvr_app_base_info,
        // body: { appId: this.sourceAppId}
        body: { appId: sourceAppId },
      });
      const { wechatAppId, pcRedirectUrl, h5RedirectUrl } = lodash.get(
        res,
        'extendInfo',
      );
      this.BaseInfo.merge({
        appInfo: { ...res, pcRedirectUrl, h5RedirectUrl },
      });
      this.User.merge({ wxAppId: wechatAppId });
      return res;
    } catch (error) {}
  }

  /** 注册获取code，并登录账号 */
  async registerUser(body) {
    const intentionBu = lodash.eq(
      this.defaultSourceAppId,
      EnumUserSourceType.isg,
    )
      ? EnumBusiness.ISG
      : lodash.get(body, 'intentionBu');

    const headers = intentionBu
      ? {
          'x-business-unit': intentionBu,
        }
      : {};

    const registerLoginCode: any = await AjaxBasics.request({
      ...EnumAPI.accountsvr_user_add,
      body: {
        ...body,
        appId: this.defaultSourceAppId,
      },
      headers,
    });
    // const res = await AjaxBasics.request({
    //     ...EnumAPI.accountsvr_user_add_login,
    //     body: { ...registerLoginCode }
    // })
    this.User.merge({ registerInfo: registerLoginCode });

    try {
      // 保存协议记录
      await this.Protocol.onSaveProtocol({
        sceneCode: EnumProtocol.register,
        userCode: lodash.get(body, 'mobile'),
      });
    } catch (error) {}

    // return res
  }

  /** 根据账号查询基本信息 */
  async getInfo(body) {
    const res = await AjaxBasics.request({
      ...EnumAPI.accountsvr_account_get_info,
      body: lodash.pick(body, ['loginId', 'imgCode', 'type']),
      headers: { 'img-session': lodash.get(body, 'imgSession') },
    });
    if (res) {
      this.User.merge(res);
    }
    return res;
  }

  /** 手机号找回密码 */
  retrievePwd(body) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_retrieve_pwd,
      body: lodash.assign(
        lodash.pick(body, ['mobile', 'password', 'verificationCode']),
        { forgetPwdToken: this.User.value.forgetPwdToken },
      ),
    });
  }

  /** 用户绑定手机号 */
  async bindMobile(body) {
    await AjaxBasics.request({
      ...EnumAPI.accountsvr_bind_mobile,
      body: lodash.assign(lodash.pick(body, ['mobile', 'verificationCode']), {
        username: this.User.username,
      }),
      // body: lodash.pick(body, ['mobile', 'verificationCode']),
    });
    // const res = await AjaxBasics.toPromise(AjaxBasics.requestObservable(EnumAPI.accountsvr_token_get_info))
    this.User.merge(lodash.pick(body, ['mobile']));
  }

  /** 校验验证码 */
  async checkCode(body) {
    const res = await AjaxBasics.request({
      ...EnumAPI.accountsvr_check_code,
      body: lodash.assign(body, {
        receiverType: EnumCaptchaType.mobile,
        scene: EnumPhoneMsgScene.editPhone,
      }),
    });
    this.checkcode = res;
  }

  /** 修改密码 */
  editPwd(body) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_edit_pwd,
      body,
    });
  }

  /** 12位01码邮箱找回密码 */
  retrieveByEmail(body) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_email_retrieve,
      body: lodash.assign(body, {
        forgetPwdToken: this.User.value.forgetPwdToken,
      }),
    });
  }

  /** 12位01码修改密码 */
  resetPwd(body) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_reset_pwd,
      body,
    });
  }

  /** 校验公司名称 */
  checkCompany(body) {
    return AjaxBasics.request({
      ...EnumAPI.partner_check_companyname,
      body,
    });
  }

  /** 校验合法域名 */
  checkDomain(body) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_check_domain,
      body,
    });
  }

  /** 政企（大客户）注册获取code，并登录账号 */
  async relRegisterUser(body) {
    const registerLoginCode: any = await AjaxBasics.request({
      ...EnumAPI.orgidass_rel_register,
      body,
    });
    // const res = await AjaxBasics.request({
    //     ...EnumAPI.accountsvr_user_add_login,
    //     body: { ...registerLoginCode }
    // })
    this.User.merge({ registerInfo: registerLoginCode });

    try {
      // 保存协议记录
      await this.Protocol.onSaveProtocol({
        sceneCode: EnumProtocol.relRegister,
        userCode: lodash.get(body, 'mobile'),
      });
    } catch (error) {}

    // return res
  }
  /** SMB快速注册获取code */
  async smbRegisterUser(body) {
    // 返回的对象
    const registerObj: any = await AjaxBasics.request({
      ...EnumAPI.orgidass_smb_register,
      body,
    });
    // const res = await AjaxBasics.request({
    //     ...EnumAPI.accountsvr_user_add_login,
    //     body: { ...registerLoginCode }
    // })

    this.User.merge({
      smbRegisterOrgInfo: registerObj,
      registerInfo: { registerLoginCode: registerObj?.registerLoginCode },
    });

    try {
      // 保存协议记录
      await this.Protocol.onSaveProtocol({
        sceneCode: EnumProtocol.smbRegister,
        userCode: lodash.get(body, 'mobile'),
      });
    } catch (error) {}

    // return res
  }
  /** SMB快速注册--加入组织 */
  async smbJoinOry() {
    // 返回的对象
    const registedManagerInfo: any = await AjaxBasics.request({
      ...EnumAPI.partner_serviceStation_smbJoinOrg,
      body: {},
    });
    // 将管理员信息存入
    this.User.merge({
      registedManagerInfo: registedManagerInfo,
    });
  }

  /** SMB快速注册--加入组织 （移动端登录信息未同步至 indexedDB，传token 防止401) */
  async smbmMbileJoinOry(token) {
    // 返回的对象
    const registedManagerInfo: any = await AjaxBasics.request({
      ...EnumAPI.partner_serviceStation_smbJoinOrg,
      body: {},
      headers: {
        'bp-token': token,
      },
    });
    // 将管理员信息存入
    this.User.merge({
      registedManagerInfo: registedManagerInfo,
    });
  }

  /**
   * 窗口期，安全手机绑定
   */
  async securityBindmobile(body) {
    const res: any = await AjaxBasics.request({
      ...EnumAPI.accountsvr_security_bindmobile,
      body,
    });
    this.User.merge({
      token: lodash.get(res, 'idToken'),
      ...res,
    });
    return res;
  }
  /**
   * 忽略绑定手机号
   */
  async ignore_bindmobile(body) {
    const res: any = await AjaxBasics.request({
      ...EnumAPI.accountsvr_ignore_bindmobile,
      body,
    });
    this.User.merge({
      token: lodash.get(res, 'idToken'),
      ...res,
    });
    return res;
  }

  /** 忘记密码/重置密码，根据账号查询基本信息 */
  async getPwdInfo(body) {
    const res = await AjaxBasics.request({
      ...EnumAPI.accountsvr_account_pwd_get_info,
      body: lodash.pick(body, ['loginId', 'imgCode', 'type']),
      headers: { 'img-session': lodash.get(body, 'imgSession') },
    });
    if (res) {
      this.User.merge(res);
    }
    return res;
  }

  /** 忘记密码/重置密码 */
  forgetPwd(body) {
    return AjaxBasics.request({
      ...EnumAPI.accountsvr_forget_pwd,
      body: lodash.assign(lodash.pick(body, ['password', 'verificationCode']), {
        forgetPwdToken: this.User.value.forgetPwdToken,
      }),
    });
  }

  async tokenGetInfo() {
    const res = await AjaxBasics.request({
      ...EnumAPI.accountsvr_token_get_info,
    });
    if (lodash.includes([1, 2], lodash.get(res, 'status'))) {
      throw { status: EnumStatusCode.newUser };
    }
  }
}
